import { render, staticRenderFns } from "./StudentInfomationReport.vue?vue&type=template&id=4da55a97&scoped=true&lang=pug&"
import script from "./StudentInfomationReport.vue?vue&type=script&lang=ts&"
export * from "./StudentInfomationReport.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInfomationReport.vue?vue&type=style&index=0&id=4da55a97&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da55a97",
  null
  
)

export default component.exports